<script setup lang="ts">
import "@/assets/css/_main.css";
import { fr } from "@nuxt/ui/locale";
import { useColorMode } from "@vueuse/core";

useColorMode().value = "light";
</script>

<template>
  <UApp :locale="fr">
    <slot />
  </UApp>
</template>
